import { normalizeLinkArtifactUrl } from '@bower/shared/utils/linkHref';
import { ANALYTICS_EVENTS } from '../../constants/analytics';
import { ROUTES } from '../../constants/routes';
import { safeAnalytics } from '../../utils/analytics';

/**
 * The Link Opened event, for a surface that opens a link through its own
 * anchor (`target="_blank"`) rather than `openLinkArtifact`. Call it from the
 * anchor's `onClick`. Properties: surface only, never the URL or title.
 */
export function trackLinkOpened(surface: string): void {
  safeAnalytics.track(ANALYTICS_EVENTS.LINK_OPENED, { surface });
}

/**
 * Open a `link` artifact (docs/planning/link-artifacts.md, D6): its page in a
 * new tab, never this one. `useEntityNavigation`'s `openEntity` delegates here
 * for links; a surface that must not import that hook (it would close an
 * import cycle through `useOpenAttachment`) calls this directly.
 *
 * `window.open` must run in the click's own task: nothing may be awaited
 * before it, or popup blockers refuse it. `href`, the stored URL when the
 * caller holds it, is used only when it normalizes (`javascript:` and the like
 * never open); otherwise `/links/:id` loads the link and replaces itself.
 */
export function openLinkArtifact(
  id: string,
  options?: { readonly href?: string; readonly surface?: string },
): void {
  const direct = options?.href ? normalizeLinkArtifactUrl(options.href) : null;
  window.open(direct ?? ROUTES.link(id), '_blank', 'noopener,noreferrer');
  trackLinkOpened(options?.surface ?? 'unknown');
}
